export enum apiBaseRoutes {
  USER = '/user',
  SERVICE = '/service',
  MANUFACTURER = '/manufacturer',
  ADMIN = '/admin',
  UPLOADS = '/uploads',
  COMPANY = '/company',
  SUPPORT_INFO = '/support-info',
  RESET = '/reset',
  CONFIG = '/config',
}

export enum apiRoutes {
  LOGIN = '/login',
  CHECK = '/check',
  SYNC = '/sync',
  TICKETS = '/tickets',
  TICKET = '/ticket',
  DEVICE = '/device',
  ACCESS = '/access',
  TICKETS_RESOLVE = '/tickets/resolve',
  NOTES = '/notes',
  MANUFACTURER_NOTES = '/manufacturer-notes',
  PARAMETERS = '/parameters',
  ERROR = '/error',
  PRODUCTS = '/products',
  SERVICE = '/service',
  MANUFACTURER = '/manufacturer',
  ASSIGN = '/assign',
  REASSIGN = '/reassign',
  FILE = '/file',
  PASSWORD = '/password',
  STATS = '/stats',
  CREATE = '/create',
  ENABLE = '/enable',
  DISABLE = '/disable',
  FULL = '/full',
  SETTING = '/setting',
  AUTO_ASSIGN = '/auto-assign',
  BULK = '/bulk',
  LIST = '/list',
  ALL = '/all',
}
